import { HandoffProvider } from '@cma/common'
import { BrowserRouter } from 'react-router-dom'
import { AppProvider } from './AppProvider'
import { AppRoutes } from './AppRoutes'

export function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <HandoffProvider>
          <AppRoutes />
        </HandoffProvider>
      </BrowserRouter>
    </AppProvider>
  )
}
